export const style = {
  Typography: {
    sx: {
      position: 'relative',
      '& .MuiInputLabel-root': {
        fontWeight: 500,
        color: 'action.active',
      },
      '& input': {
        fontWeight: 400,
        color: 'action.active',
      },
    },
  },
  inputLabel: {
    position: 'absolute',
    right: '0px',
    top: '15px',
    textAlign: 'end',
    width: '100%',
  },
} as const;
